/**
 * Created by joli on 8/7/17.
 */
import React, { PureComponent } from "react";
import * as styles from "../../styles/components/PickCTAs.css";

export default class ThumbnailGrid extends PureComponent {
    constructor(props) {
        super(props);

        this.styles = {
            horizontal: {
                grid: `${styles.thumbnailGrid} ${styles.horizontal}`,
                items: `${styles.itemsContainer} ${styles.horizontal}`,
                selectedTile: `${styles.selectedTile} ${styles.horizontal}`,
                badge: `${styles.badge} ${styles.horizontal}`
            },

            vertical: {
                grid: `${styles.thumbnailGrid} ${styles.vertical}`,
                items: `${styles.itemsContainer} ${styles.vertical}`,
                selectedTile: `${styles.selectedTile} ${styles.vertical}`,
                badge: `${styles.badge} ${styles.vertical}`
            }
        };

        this.style = this.props.horizontalLayout
            ? this.styles.horizontal
            : this.styles.vertical;
    }

    renderBadge(count) {
        if (count > 0) {
            return (
                <div className={this.style.badge}>
                    <p>{count}</p>
                </div>
            );
        }
    }

    onTileClick(page, event) {
        const { selectPage } = this.props;
        selectPage(page);
    }

    renderTile(page) {
        const { image, ctas } = page;
        const imageUrl = image.files.original.imageUrl;
        const activeCtas = ctas.reduce((count, cta) => {
            if (cta && cta.isActive) {
                count++;
            }
            return count;
        }, 0);

        return (
            <div className={styles.imgContainer}>
                <div
                    className={styles.thumbnailImg}
                    style={{ backgroundImage: `url(${imageUrl})` }}
                >
                    {this.renderBadge(activeCtas)}
                </div>
                <div className={styles.caption}>
                    <div>{page.name}</div>
                </div>
            </div>
        );
    }

    renderItems() {
        const { pages, selectedPage } = this.props;

        const tiles = pages.map(page => {
            const isSelected = page.id === selectedPage.id;
            const tileStyle = isSelected
                ? this.style.selectedTile
                : styles.tile;

            return (
                <div
                    key={page.id}
                    className={tileStyle}
                    onClick={this.onTileClick.bind(this, page)}
                >
                    {this.renderTile(page, selectedPage)}
                </div>
            );
        });

        return tiles;
    }

    render() {
        return (
            <div className={this.style.grid}>
                <div className={this.style.items}>{this.renderItems()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/ThumbnailGrid.js